import { useState } from "react";
import {
  Col,
  Row,
  Divider,
  Typography,
  Button,
  Space,
  Avatar,
  Card,
} from "antd";
import { Title } from "../Title/Title";
import Sector1 from "@assets/KPMG/Sector/1.svg";
import Sector2 from "@assets/KPMG/Sector/2.svg";
import Sector3 from "@assets/KPMG/Sector/3.svg";
import Sector4 from "@assets/KPMG/Sector/4.jpg";
import Sector5 from "@assets/KPMG/Sector/5.jpg";
import { useNavigate } from "react-router-dom";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

export const InvestmentAcrossSector = () => {
  const navigate = useNavigate();
  const [selectedSector, setSelectedSector] = useState<string>("");
  const sectorList: any = [
    {
      step: "01",
      title: "Utility",
      image: Sector1,
      description:
        "Comprehensive projects are specifically designed to meet the expanding demands of urbanization for our communities.",
      redirectTo: "",
    },
    {
      step: "02",
      title: "Energy",
      description:
        "In this sector we will explore the energy projects，highlighting their pivotal role in renewable energy generation and sustainable development.",
      redirectTo: "",
      image: Sector2,
    },
    {
      step: "03",
      title: "Built Environment",
      description:
        "A wide range of initiatives aimed at expanding, upgrading, and modernizing infrastructure to meet the growing demands.",
      redirectTo: "",
      image: Sector3,
    },
    {
      step: "04",
      title: "Transportation",
      description:
        "Our transportation sector focuses on innovative projects to enhance connectivity, efficiency, and sustainability in the movement of people and goods, fostering economic growth and accessibility.",
      redirectTo: "",
      image: Sector4,
    },
    {
      step: "05",
      title: "Social Infrastructure",
      description:
        "Focusing on the core elements that nurture and sustain our communities, social infrastructure projects encompass the development and enhancement of vital institutions like hospitals and schools.",
      redirectTo: "",
      image: Sector5,
    },
  ];

  const visibleData: any = [
    {
      id: 1,
      name: "Sharad Somani",
      department: "Partner, Infrastructure Advisory",
      description:
        "Sharad has more than 25 years’ experience in infrastructure sectors, covering transport; broadband; urban/industrial infrastructure; and power (renewable energy, water, waste to energy) and liquefied natural gas.",
      location: "KMPG Singapore",
    },
    {
      id: 2,
      name: "Deven Chhaya",
      department: "Partner, Infrastructure Advisory",
      location: "KMPG Singapore",
      description:
        "Deven leads infratech advisory services armed with more than 25 years’ industry experience in ports, smart cities and energy and utilities, he has led numerous transformation efforts in energy transition, technology and citizen services.",
    },
    {
      id: 3,
      name: "Wen Bin Lim",
      department: "Director, Infrastructure Advisory",
      description:
        "Wen Bin brings over 15 years of Singapore energy market experience and has advised on electricity market design, energy market reform and policy and regulation internationally",
      location: "KMPG Singapore",
    },
    {
      id: 4,
      name: "Abhishek Dubey",
      department: "Associate Director, Infrastructure Advisory",
      location: "KMPG Singapore",
      description:
        "Has more than 14 years of consulting experience in digital transformation, digital strategy, IT strategy, and related projects. He has worked extensively with public sector clients driving programs and projects on Digital Strategy, Data Strategy, Innovation, and Technology implementation.",
    },
  ];

  const navigateTo = (url: string) => {
    navigateTo(url);
  };
  return (
    <>
      <div
        className="investment-across-sector"
        id="investment-across-sector"
        style={{ paddingTop: 10 }}
      >
        <Typography.Title level={3} style={{ color: "#fff", marginBottom: 0 }}>
          Decarb Projects Across Sector
        </Typography.Title>
        <Row>
          {/* <Col lg={2}></Col> */}
          <Col lg={24} sm={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Swiper
                  style={{ padding: "20px 40px 40px 40px" }}
                  // install Swiper modules
                  modules={[Navigation, Pagination, A11y, Autoplay]}
                  spaceBetween={40}
                  slidesPerView={3}
                  navigation={true}
                  autoplay={{ delay: 4000, pauseOnMouseEnter: true }}
                  // loop={true}
                  // loopedSlides={2}
                  grabCursor={true}
                  pagination={{ clickable: true }}
                  scrollbar={{ draggable: true }}
                >
                  {sectorList.map((sector: any, index: number) => (
                    <SwiperSlide style={{ height: "auto" }} key={index}>
                      <div
                        style={{
                          height: "100%",
                          marginLeft: 20,
                          marginRight: 20,
                          minWidth: 300,
                          maxWidth: 360,
                        }}
                      >
                        <Space direction="vertical" size="middle">
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              // setSelectedSector(sector.title);
                              navigate(
                                `/investment-hub?sector=${sector.title}`
                              );
                            }}
                          >
                            <div
                              style={{
                                background:
                                  selectedSector === sector.title
                                    ? "#fd349c"
                                    : "#1E49E2",
                                paddingTop: 10,
                                paddingBottom: 10,
                              }}
                            >
                              <div
                                style={{ textAlign: "right", paddingRight: 20 }}
                              >
                                <Typography.Title
                                  level={4}
                                  style={{ marginBottom: 0, color: "#fff" }}
                                >
                                  {sector.step}
                                </Typography.Title>
                              </div>
                              <div style={{ padding: "0 20px" }}>
                                <Typography.Title
                                  level={3}
                                  style={{ color: "#fff", marginBottom: 0 }}
                                >
                                  {sector.title}
                                </Typography.Title>
                              </div>
                            </div>
                            <div>
                              <div style={{ position: "relative" }}>
                                <img
                                  src={sector.image}
                                  style={{
                                    maxWidth: "100%",
                                    width: "100%",
                                    height: 300,
                                    objectFit: "cover",
                                  }}
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                  }}
                                >
                                  <div
                                    style={{
                                      maxWidth: "80%",
                                      margin: "20px auto",
                                    }}
                                  >
                                    <Typography.Text
                                      className="textSmall"
                                      style={{ color: "#fff" }}
                                    >
                                      {sector.description}
                                    </Typography.Text>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Space>
                      </div>
                      {/* </Col> */}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
              {/* {sectorList.map((sector: any, sIndex: number) => (
                <Col span={4} key={`sector-${sIndex}`}>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedSector(sector.title)}
                  >
                    <div
                      style={{
                        background:
                          selectedSector === sector.title
                            ? "#fd349c"
                            : "#1E49E2",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      <div style={{ textAlign: "right", paddingRight: 10 }}>
                        <Typography.Title
                          level={4}
                          style={{ marginBottom: 10, color: "#fff" }}
                        >
                          {sector.step}
                        </Typography.Title>
                      </div>
                      <div style={{ padding: "0 20px" }}>
                        <Typography.Title level={3} style={{ color: "#fff" }}>
                          {sector.title}
                        </Typography.Title>
                      </div>
                    </div>
                    <div>
                      <div style={{ position: "relative" }}>
                        <img
                          src={sector.image}
                          style={{
                            maxWidth: "100%",
                            width: "100%",
                            height: 300,
                            objectFit: "cover",
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                          }}
                        >
                          <div style={{ maxWidth: "80%", margin: "20px auto" }}>
                            <Typography.Text
                              className="textSmall"
                              style={{ color: "#fff" }}
                            >
                              {sector.description}
                            </Typography.Text>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))} */}
            </Row>
            <Row>
              <Col span={24} style={{ paddingTop: 0 }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="primary"
                    className="btn-primary"
                    onClick={() => {
                      if (selectedSector) {
                        navigate(`/investment-hub?sector=${selectedSector}`);
                      } else {
                        navigate(`/investment-hub`);
                      }
                    }}
                  >
                    VIEW ALL PROJECTS
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
          {/* <Col lg={2}></Col> */}
        </Row>
      </div>
    </>
  );
};
